import { IErrors, IFormValues } from './types';

export const validateWalletUserMappingForm = (values: IFormValues) => {
    const errors: IErrors = { Mappings: [...Array(values.Mappings.length)].map(() => ({})) };
    let mappingError = false;

    values.Mappings.forEach((mapping, index) => {
        if (!mapping.User) {
            errors.Mappings[index].User = 'Required';
            mappingError = true;
        }

        if (!mapping.Role) {
            errors.Mappings[index].Role = 'Required';
            mappingError = true;
        }
    });

    if (!mappingError) return {} as IErrors;

    return errors;
};